import {
  mergeStyleSets
} from "@fluentui/react";

export const useMessageBarClasses = mergeStyleSets({
  container: {
    top: "60px",
    left: "0px",
    display: "block",
    position: "absolute",
    right: "0px",
    height: "37px",
    zIndex: "250",
  },
});
